module.exports = __webpack_public_path__ + "static/media/diy_kyc.3b1f8084.svg";